import { NGXS_META_KEY } from './helpers';

export function createAction<_U, S extends new (...args: any) => any>(
  fn: string,
  store: S,
  payload?: any,
): { payload: any } {
  // @ts-ignore
  const name = store[NGXS_META_KEY].path;
  return new (class {
    public static type: string = `[${name}] ${fn}`;
    public payload: any = payload;
  })();
}

export const ENTITY_STATE_ACTIONS = {
  EntitySetActive: {
    fnName: 'setActiveHandler',
    actionName: 'EntitySetActive',
  },
  EntitySaveMany: {
    fnName: 'saveManyHandler',
    actionName: 'EntitySaveMany',
  },
  ClearEntityState: {
    fnName: 'clearHandler',
    actionName: 'ClearEntityState',
  },
};

type EntityStateMethodParam<
  T extends new (...args: any) => any,
  M extends string,
  P extends number
> = Parameters<InstanceType<T>[M]>[P];

export class EntitySetActive<T extends new (...args: any) => any> {
  constructor(target: T, id: EntityStateMethodParam<T, 'markAsActive', 1>) {
    return createAction(ENTITY_STATE_ACTIONS.EntitySetActive.actionName, target, id);
  }
}

export class EntitySaveMany<T extends new (...args: any) => any> {
  constructor(target: T, payload: EntityStateMethodParam<T, 'saveMany', 2>) {
    return createAction(ENTITY_STATE_ACTIONS.EntitySaveMany.actionName, target, payload);
  }
}

export class ClearEntityState<T extends new (...args: any) => any> {
  constructor(target: T) {
    return createAction(ENTITY_STATE_ACTIONS.ClearEntityState.actionName, target);
  }
}
